<template>
  <Content
    header-image-src="/img/content/img-contents-thumb-2l.webp"
    :header-title="['USIM 총알배송으로', '오늘 받아보세요']"
    date="2026.06.16"
  >
    <p class="typo-1 mt-8 mb-30">
      해외여행을 준비하다 보면 예상치 못한 일이 생기거나 시간이 부족해 당황스러울 때가 있죠. 특히,
      해외에서 필수적인 데이터 연결을 위한 USIM 준비가 늦어졌다면 고민이 커질 수 있어요. 하지만
      걱정하지 마세요! 유심사는 총알배송 서비스를 지원하고 있어요.
    </p>

    <div class="title-typo-1 bg-gray mb-default">오늘 주문 오늘 도착, 총알 배송 🚀</div>
    <p class="typo-1 mt-8 mb-default">
      여행자님의 시간을 소중히 생각하는 마음에서 총알배송이 도입되었어요. 오늘 주문하고 오늘
      받아보세요! <b>평일 오후 1시까지 결제</b> 시, 주문 접수와 동시에 발송 준비가 시작돼요.
    </p>
    <div class="typo-1 mt-8 mb-30">
      <b>총알배송 가능 지역:</b><br />
      <ul>
        <li>서울 전 지역</li>
        <li>경기/인천/대전/세종/청주/원주 일부 지역</li>
      </ul>
    </div>
    <nuxt-img
      src="/img/content/img-contents2-image1.webp"
      class="w-full mb-default"
    />
    <nuxt-img
      src="/img/content/img-contents2-image2.webp"
      class="w-full"
    />
    <p class="typo-1 mt-8 mb-30">
      수도권 외 지역은 우체국 택배로 발송되며, 평균 1~3일 이내에 받아보실 수 있어요.<br />
      <b>배송지 입력 시 총알배송 가능 여부를 간편하게 확인</b>할 수 있으니, 주소를 꼭 확인해 주세요!
    </p>
    <nuxt-img
      src="/img/content/img-contents2-image3.webp"
      class="w-full"
    />

    <!-- <Separator class="mt-30 mb-30" /> -->

    <!-- <div class="title-typo-1 bg-gray mb-default">무료배송 혜택 🎁</div>
    <p class="typo-1 mt-8 mb-default">
      유심사 홈페이지에서 USIM을 구매한 모든 여행자님께 무료배송 혜택을 제공하고 있어요.
      <b>배송비 걱정 없이 빠르게 USIM을 받아보세요!</b>
    </p>
    <p class="typo-3">※ 혜택 기간은 사전 공지 없이 종료될 수 있어요.</p> -->
  </Content>
</template>
<script setup lang="ts">
definePageMeta({
  layout: 'center'
})
useHead({
  title: 'USIM 총알배송으로 오늘 받아보세요',
  meta: [
    {
      hid: 'description',
      name: 'description'
    }
  ]
})
</script>
